module.exports = __webpack_public_path__ + "static/mobile-product-d2a1fbd7bb7cd65ec38e724d9a99ee25.png";